export const TIME_BASED_MEDIA_TYPES = ['Radio', 'Rádio', 'TV', 'Podcast'];

export const isTimeBasedMedia = (articleOrMediaType) => {
  const mediaType = typeof articleOrMediaType === 'string'
    ? articleOrMediaType
    : articleOrMediaType?.mediaType;
  return TIME_BASED_MEDIA_TYPES.includes(mediaType);
};

export const getEditorialOccupancy = (article) => (
  article?.editorialOccupancy || article?.onlineCentimetragem || {}
);

export const getTotalDurationSeconds = (article) => {
  const occupancy = getEditorialOccupancy(article);
  return Number(occupancy.totalDurationSeconds || article?.durationSeconds || 0);
};

export const getBrandDurationSeconds = (article) => {
  const occupancy = getEditorialOccupancy(article);
  const explicit = Number(occupancy.brandDurationSeconds || 0);
  if (explicit > 0) return explicit;
  const total = getTotalDurationSeconds(article);
  const rawShare = Number(occupancy.brandParticipationPercent || 0);
  const share = rawShare > 1 ? rawShare / 100 : rawShare;
  return total > 0 && share > 0 ? total * share : 0;
};

export const formatDuration = (seconds) => {
  const value = Math.max(0, Math.round(Number(seconds) || 0));
  const hours = Math.floor(value / 3600);
  const minutes = Math.floor((value % 3600) / 60);
  const remainingSeconds = value % 60;
  return hours > 0
    ? [hours, minutes, remainingSeconds].map(part => String(part).padStart(2, '0')).join(':')
    : [minutes, remainingSeconds].map(part => String(part).padStart(2, '0')).join(':');
};

export const parseDuration = (value) => {
  if (value === null || value === undefined || value === '') return 0;
  const text = String(value).trim();
  if (!text.includes(':')) {
    const numeric = Number(text.replace(',', '.'));
    return Number.isFinite(numeric) ? Math.max(0, numeric) : 0;
  }
  const parts = text.split(':').map(Number);
  if (parts.some(part => !Number.isFinite(part) || part < 0) || parts.length > 3) return 0;
  return parts.reduce((total, part) => total * 60 + part, 0);
};
